import React, { useEffect, useState } from "react";
import { fireCustomLinkClickGA } from "@directv-digital/dds.services.analytics-service"

export interface YotpoPackageRatingProps {
  enableStarRating ?: boolean;
  starColor?: string;
  enableYotpoReview?: boolean;
  appKey?: string;
  analyticsLinkName?: string;
  productId?: string;
  scriptSrc?: string;
  yotpoAttributes?: {
    className?: string;
    data_yotpo_instance_id?: string;
    data_yotpo_product_id?: string;
    [key: string]: any; // For additional field if any
  }
}

export const YotpoPackageRating = (props: YotpoPackageRatingProps) => {
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const appKey =  props.appKey || "W8MDa4JClXLdME9zf4AJG79SnaMwQsqU1vCRLyLh";
  const initializeYotpo = () => {
    if (window?.yotpo) {
      console.log('Initializing Yotpo widgets');
      setTimeout(() => {
        if (window.yotpo.initWidgets) {
          window.yotpo.initWidgets();
        } else {
          console.log('Yotpo initWidgets method is not available');
        }
      }, 500);
    } else {
      console.log('Yotpo object is not available on the window');
    }
  };
  useEffect(() => {
    if (typeof document !== "undefined" && props?.enableStarRating) {
      const existingScript = document.querySelector(`script[src="${props?.scriptSrc}"]`);
      if (!existingScript) {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.src = `${props?.scriptSrc}`;
        script.onload = () => {
          setScriptLoaded(true);
          initializeYotpo();
        };
        script.onerror = () => {
          setScriptLoaded(false);
        };
        document.body.appendChild(script);
      } else {
        setScriptLoaded(true);
      }
    }
  }, [appKey]);
  useEffect(() => {
    if (scriptLoaded) {
      const yotpoWidgetContainer = document.querySelector('.yotpo.bottomLine');
      if (yotpoWidgetContainer) {
        initializeYotpo();
      }
    }
  }, [scriptLoaded]);
  useEffect(() => {
    const applyStyles = () => {
      const yotpoBottomLineDiv = document.querySelector('.yotpo.bottomLine');
      if (yotpoBottomLineDiv) {
        const spans = yotpoBottomLineDiv.querySelectorAll(
          '.yotpo-icon.yotpo-icon-star.rating-star.pull-left, .yotpo-icon.yotpo-icon-half-star.rating-star.pull-left'
        );
        spans.forEach(span => {
          (span as HTMLElement).style.color = props?.starColor || '#e7721b';
        });
        const textElements = yotpoBottomLineDiv.querySelectorAll('.yotpo .text-m');
        textElements.forEach(textElement => {
          (textElement as HTMLElement).style.fontSize = '16px';
          (textElement as HTMLElement).style.marginLeft = '16px';
        });
      }
    }
    applyStyles();

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.addedNodes.length > 0) {
          applyStyles();
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    return () => {
      observer.disconnect();
    };
  }, []);

  const handleStarRatingClick = () => {
    const customAnalytics = {
      event: "trackEvent",
      event_name: "custom_link_click",
      linkName: props?.analyticsLinkName,
      linkPosition: 'body',
      linkDestination: window?.location?.href
    };
    console.log('customAnalytics', customAnalytics);
    fireCustomLinkClickGA(customAnalytics);
  };
  const transformKeys = (obj: { [key: string]: any }) => {
    const newObj: { [key: string]: any } = {};
    // eslint-disable-next-line guard-for-in
    for (const key in obj) {
      const newKey = key.replace(/_/g, '-');
      newObj[newKey] = obj[key];
    }
    return newObj;
  };
  const transformedyotpoConfig = transformKeys(props?.yotpoAttributes);
  const getYotpoWidgetStarRating = () => (
       <>
         <div className={transformedyotpoConfig.className} {...transformedyotpoConfig} onClick={handleStarRatingClick}></div>
       </>
  )
  return (
    <>
      {props?.enableStarRating  && getYotpoWidgetStarRating()}
    </>
  )
}

export default YotpoPackageRating;
